import { addGroup } from './states';

export const services = {
  addGroup,
};
